module.exports = __webpack_public_path__ + "img/apk.0f6f571e.png";